<hive-button
    label="Renew"
    emphasis="primary"
    [isLoading]="actionInProgress()"
    [disabled]="!eosc().allowRenew() || actionInProgress()"
    hiveTooltip
    [hiveTooltipDescription]="tooltip()"
    (click)="renew.emit()"
></hive-button>
